import bubbleUtils from './BubblesUtils';
import shapeTypes from '../../../../constants/ShapeConstants';

const speakBubbleUtils = {
    sectorPosition: 15, // sector gap width (in percent)

    getPath (shapeModel) {
        var shapePoints = this.createShapePoints(shapeModel);
        var stemPoints = this.getStemPosition(shapeModel, shapePoints);

        var path;

        if (shapeModel.type == shapeTypes.COMPLEX_SPEAK_BUBBLE)
            path = this.createComplexPath(shapeModel, stemPoints);
        else
            path = this.createPath(shapeModel, stemPoints);

        return path;
    },
    createPath (shapeModel, points) {
        if (points[0] == undefined || shapeModel == undefined)
            return '';

        var data = `M${points[0].x - shapeModel.x},${points[0].y - shapeModel.y}`;
        const length = points.length;
        var i;
        var point;

        for (i=1; i<length; i++) {
            point = points[i];
            point.x = point.x - shapeModel.x;
            point.y = point.y - shapeModel.y;
            data += 'L' + point.x + ',' + point.y;
        }

        return data;
    },
    createComplexPath (shapeModel, points) {
        if (points[0] == undefined || shapeModel == undefined)
            return '';

        var data = '';
        const length = points.length;
        var i;
        var point;

        for (i=0; i<length; i++) {
            point = points[i];
            var x = point.x - shapeModel.x;
            var y = point.y - shapeModel.y;

            var type = 'L';

            if (i % 3 == 0)
                type = 'M';

            data += type + x + ',' + y;
        }

        return data;
    },
    createSectors (shapeModel) {
        let {x, y, width, height} = shapeModel;
        let start;
        let end;
        let sectors = [];
        const offset = 20;
        const strokeOffset = shapeModel.isMindMap ? 0 : (shapeModel.strokeWidth + 1);
        let sectorPosition = shapeModel.isMindMap ? 0 : this.sectorPosition;

        x = x + strokeOffset;
        y = y + strokeOffset;
        width = width - 2 * strokeOffset;
        height = height -2 * strokeOffset;

        start = y + height * (100 - sectorPosition)/100 - offset;
        end = y + height - offset;
        sectors.push(0);
        sectors.push({start, end});

        start = x + width * (100 - sectorPosition)/100 - offset;
        end = x + width - offset;
        sectors.push({start, end});

        start = x + offset;
        end = x + width * sectorPosition/100 + offset;
        sectors.push({start, end});

        start = y + height * (100 - sectorPosition)/100 - offset;
        end = y + height - offset;
        sectors.push({start, end});

        start = y + offset;
        end = y + height * sectorPosition/100 + offset;
        sectors.push({start, end});

        start = x + offset;
        end = x + width * sectorPosition/100 + offset;
        sectors.push({start, end});

        start = x + width * (100 - sectorPosition)/100 - offset;
        end = x + width - offset;
        sectors.push({start, end});

        start = y + offset;
        end = y + height * sectorPosition/100 + offset;
        sectors.push({start, end});

        return sectors;
    },
    createShapePoints (shapeModel) {
        let {x, y, width, height} = shapeModel;
        var sectors = this.createSectors(shapeModel);
        var points = [];
        const strokeOffset = shapeModel.isMindMap ? 0 : (shapeModel.strokeWidth / 2 + 1);

        x = x + strokeOffset;
        y = y + strokeOffset;
        width = width - 2 * strokeOffset;
        height = height -2 * strokeOffset;

        points.push({x, y});
        points.push({x:sectors[6].start, y});
        points.push({x:sectors[6].end, y});
        points.push({x:sectors[6].end, y});
        points.push({x:sectors[7].start, y});
        points.push({x:sectors[7].end, y});
        points.push({x:sectors[7].end, y});
        points.push({x:width + x, y});
        points.push({x:width + x, y:sectors[8].start});
        points.push({x:width + x, y:sectors[8].end});
        points.push({x:width + x, y:sectors[8].end});
        points.push({x:width + x, y:sectors[1].start});
        points.push({x:width + x, y:sectors[1].end});
        points.push({x:width + x, y:sectors[1].end});
        points.push({x:width + x, y:height + y});
        points.push({x:sectors[2].end, y:height + y});
        points.push({x:sectors[2].start, y:height+ y});
        points.push({x:sectors[2].start, y:height + y});
        points.push({x:sectors[3].end, y:height + y});
        points.push({x:sectors[3].start, y:height + y});
        points.push({x:sectors[3].start, y:height + y});
        points.push({x, y:height + y});
        points.push({x, y:sectors[4].end});
        points.push({x, y:sectors[4].start});
        points.push({x, y:sectors[4].start});
        points.push({x, y:sectors[5].end});
        points.push({x, y:sectors[5].start});
        points.push({x, y:sectors[5].start});
        points.push({x, y});

        return points;
    },
    getStemPosition (shapeModel, points) {
        let stemPoints = [];
        var controlPoints = [];

        controlPoints.push({x: shapeModel.cx, y: shapeModel.cy});

        if (shapeModel.cx1 && shapeModel.cy1)
            controlPoints.push({x: shapeModel.cx1, y: shapeModel.cy1});

        if (shapeModel.cx2 && shapeModel.cy2)
            controlPoints.push({x: shapeModel.cx2, y: shapeModel.cy2});

        if (shapeModel.cx3 && shapeModel.cy3)
            controlPoints.push({x: shapeModel.cx3, y: shapeModel.cy3});

        if (shapeModel.cx4 && shapeModel.cy4)
            controlPoints.push({x: shapeModel.cx4, y: shapeModel.cy4});

        if (shapeModel.cx5 && shapeModel.cy5)
            controlPoints.push({x: shapeModel.cx5, y: shapeModel.cy5});

        for (var i=0; i<controlPoints.length; i++) {
            const currentSector = bubbleUtils.getActiveSector(shapeModel, controlPoints[i]);
            var newIndex = -1;

            switch (currentSector) {
                case 1: {
                    newIndex = 12;
                    break;
                }
                case 2: {
                    newIndex = 16;
                    break;
                }
                case 3: {
                    newIndex = 19;
                    break;
                }
                case 4: {
                    newIndex = 23;
                    break;
                }
                case 5: {
                    newIndex = 26;
                    break;
                }
                case 6: {
                    newIndex = 2;
                    break;
                }
                case 7: {
                    newIndex = 5;
                    break;
                }
                case 8: {
                    newIndex = 9;
                    break;
                }
            }

            stemPoints.push(points[newIndex - 1]);
            stemPoints.push(controlPoints[i]);
            stemPoints.push(points[newIndex + 1]);
        }

        return stemPoints;
    }
};

export default speakBubbleUtils;



/** WEBPACK FOOTER **
 ** ./src/components/slide/shapes/utils/SpeakBubbleUtils.js
 **/